import React from "react";
import { Chip } from "@mui/material";
import { Check, CloseOutlined, ErrorOutlineOutlined } from "@mui/icons-material";

/* Marco común de las secciones del formulario de evento: el encabezado
 * plegable, el chip de "Requerido", el indicador de error y el botón de cerrar.
 *
 * Cada sección repetía este mismo bloque de markup, con diferencias mínimas
 * entre creación y edición. Acá vive una sola vez. */
const SeccionEvento = ({
  id,
  titulo,
  descripcion,
  tituloExpandido,
  requerido = false,
  tieneError = false,
  abierta,
  onToggle,
  children,
}) => (
  <div
    className={`seccion-evento ${abierta ? "expanded" : ""} ${tieneError ? "has-error" : ""}`}
    onClick={() => onToggle(id)}
  >
    <div className="d-flex justify-content-between align-items-center mb-2">
      <div className="d-flex justify-content-between align-items-center gap-3">
        <p className={`titulo-seccion-evento ${abierta ? "hidden" : ""}`}>{titulo}</p>
        {requerido && (
          <Chip
            className={abierta ? "hidden" : ""}
            icon={<Check sx={{ color: "#5656FF !important" }} />}
            size="small"
            label="Requerido"
            sx={{ backgroundColor: "#E6E6FF", color: "#5656FF" }}
          />
        )}
      </div>
      {tieneError && (
        <ErrorOutlineOutlined
          sx={{ color: "red", display: abierta ? "none" : "block" }}
        />
      )}
    </div>

    <p className={`descrip-seccion-evento ${abierta ? "hidden" : ""}`}>{descripcion}</p>

    {abierta && (
      <div className="contenido-evento">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <p className="titulo-seccion-evento-expanded">{tituloExpandido ?? titulo}</p>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onToggle(id);
            }}
            className="d-flex justify-content-end"
            aria-label={`Cerrar ${titulo}`}
          >
            <CloseOutlined sx={{ color: "#3659E3" }} />
          </button>
        </div>
        {/* los clicks dentro del contenido no deben plegar la sección */}
        <div onClick={(e) => e.stopPropagation()}>{children}</div>
      </div>
    )}
  </div>
);

export default SeccionEvento;
